export const table_filters = (state) => state.reactTable.table_filters;
